angular.module('controllers')
  .controller('CatalogueCtrl', ["$rootScope", "$scope", "$state", "ItemsService", "$window",
    function($rootScope, $scope, $state, ItemsService, $window) {

      $scope.items = [];

      //Make filters permanent between pages
      if(!$rootScope.catalogueFilterObj){
        $rootScope.catalogueFilterObj = {
          q : {
            s: ['collection_year desc', 'collection_id asc', 'model_code asc'],
            catalogue_eq : true,
            collection_season_id_in : [],
            colors_id_in : [],
            gender_id_in:[],
            compositions_textile_fibre_id_in : [],
            collection_clothing_brand_customer_id_in : [],
            collection_year_in: [],
            collection_clothing_brand_id_in : [],
            gauges_id_in : [],
            look_look_category_id_in : [],
            yarns_id_in : [],
            secondary_materials_secondary_material_category_id_in : [],
            stitches_stitch_category_id_in : [],
            decoration_patterns_decoration_pattern_category_id_in : [],
            adornments_adornment_category_id_in : [],
            finishings_finishing_category_id_in : []
          }
        };
      }

      angular.element($window).on('resize', function() {
        if($state.is('catalogue')){
          if(calculateItems() > $scope.per_page){
            $scope.per_page = (calculateItems() < 16) ? 16 : calculateItems();
            $scope.page = 1;
            $scope.stopScrolling = false;
            $scope.items = [];
            $scope.updateStitchesName();
            $scope.getItems();
          }
        }
      });

      var calculateItems = function(){
        var itemsContainerStyle = window.getComputedStyle(document.getElementById('catalogue-items-container'), null);
        var height = window.innerHeight;
        var width  = parseInt(itemsContainerStyle.getPropertyValue("width"));

        var row = Math.floor(width / 200);
        var column = Math.ceil(height / 130); //Item with no image

        return row * column;
      };

      $scope.notDownloadInfo = true;
      $scope.busy = false;
      $scope.page = 1;
      $scope.per_page = (calculateItems() < 16) ? 16 : calculateItems();

      $scope.getItems = function(){
        //Synch callback
        if ($scope.busy) return;

        $scope.busy = true;
        var serializedQ = ItemsService.param($scope.catalogueFilterObj);
        ItemsService.getFilteredItems().get(
          {
            page : $scope.page,
            per_page : $scope.per_page,
            q : serializedQ  //No vuoto
          },
          function success(data,responseHeaders){
            //$scope.items = data;
            $scope.total = responseHeaders('total');

            if (data.length === 0) {
              $scope.stopScrolling = true;
            }

            //Push new items
            angular.forEach(data, function (e) {
              $scope.update(e);
              $scope.items.push(e);
            });
            $scope.page += 1;
            $scope.busy = false;
            $scope.notDownloadInfo = false;
          },
          function error(err){
            console.log(err);
          }
        );
      };

      if(!(angular.equals({}, $rootScope.resources))){
        $scope.getItems();
      }

      var resourceLoaded = $rootScope.$on('resource:loaded', function() {
        $scope.getItems();
      });

      var unbind = [resourceLoaded];
      $scope.$on('$destroy', function () {
        unbind.forEach(function (fn) {
          fn();
        });
      });


      $scope.$watch(function(){return $rootScope.catalogueFilterObj;}, function(newVal, oldVal){
        if(newVal != oldVal && newVal !== undefined){
          $scope.page = 1;
          $scope.stopScrolling = false;
          $scope.items = [];
          $scope.getItems();
        }
      },true);

      var mobileAndTabletcheck = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      };

      $scope.showInfoButton = function() {
        if (mobileAndTabletcheck()) {
          return true;
        } else {
          return false;
        }

      };

      $scope.infoContainerTabletOpen = '';

      $scope.showInfoContainerTablet = function(item) {
        return $scope.infoContainerTabletOpen = item.id;
      };

      $scope.closeInfoContainerTablet = function() {
        return $scope.infoContainerTabletOpen = '';
      };

      // Update
      $scope.update = function (item) {
        $scope.updateStitchesName(item);
        $scope.updateColorsName(item);
        $scope.updateGaugesName(item);
        $scope.updateSecondaryMaterialsName(item);
      };

      // Update stitches name
      $scope.updateStitchesName = function(item) {
        item.stitchesResourceName = [];
        item.stitches.forEach(function(stitch) {
          if($rootScope.resources.stitches.hashmap[stitch.stitch_id]) {
            item.stitchesResourceName.push({ "name" : $rootScope.resources.stitches.hashmap[stitch.stitch_id].name});
          }
        });
      };

      // Update colors name
      $scope.updateColorsName = function(item) {
        item.colorsResourceName = [];
        item.colors.forEach(function(color) {
          if($rootScope.resources.colors.hashmap[color.color_id]) {
            item.colorsResourceName.push({ "name" : $rootScope.resources.colors.hashmap[color.color_id].name});
          }
        });
      };

      // Update gauges name
      $scope.updateGaugesName = function(item) {
        item.gaugesResourceName = [];
        $rootScope.resources.gauges.data.forEach(function(elem) {
          var check = false;
          item.gauges.forEach(function(gauge) {
            if (gauge.gauge_id == elem.id) {
              check = true;
            }
          });
          if(check) {
            item.gaugesResourceName.push({ "name" : elem.name});
          }
        });
      };

      // Update secondary materials name
      $scope.updateSecondaryMaterialsName = function(item) {
        item.secondaryMaterialsResourceName = [];
        item.secondary_materials.forEach(function(secondary_m) {
          if($rootScope.resources.secondaryMaterials.hashmap[secondary_m.secondary_material_id].name) {
            item.secondaryMaterialsResourceName.push({ "name" : $rootScope.resources.secondaryMaterials.hashmap[secondary_m.secondary_material_id].name});
          }
        });
      };

    }
  ]);
